import styles from "./EmptyState.module.css";

import { BrandLogo, PlusIcon } from "@/components/icons";

interface EmptyStateProps {
  onAdd: () => void;
}

/** The first-run card, shown while the timesheet holds no rows. */
export function EmptyState({ onAdd }: EmptyStateProps) {
  return (
    <section className={styles.card} aria-labelledby="timesheet-empty-title">
      <BrandLogo className={styles.logo} role="presentation" aria-label={undefined} aria-hidden />
      <div className={styles.text}>
        <h2 id="timesheet-empty-title" className={styles.title}>
          Start the clock when you start the work
        </h2>
        <p className={styles.body}>
          Add a row and it runs immediately. Name it and pick its Accelo task while the timer
          counts. Publish the day in one press when it ends.
        </p>
      </div>
      <button type="button" className={styles.add} onClick={onAdd}>
        <PlusIcon className={styles.addIcon} />
        Add task
      </button>
    </section>
  );
}
